module.exports = function() {
  return new Worker(__webpack_public_path__ + "32f069c181492300a1a2.worker.js");
};